// extracted by mini-css-extract-plugin
export var card = "MemberVideos-module--card--a5a84";
export var cardDescr = "MemberVideos-module--cardDescr--58a7f";
export var cardTitle = "MemberVideos-module--cardTitle--55427";
export var cta = "MemberVideos-module--cta--c4d5b";
export var grid = "MemberVideos-module--grid--3c78c";
export var iframe = "MemberVideos-module--iframe--5e034";
export var intro = "MemberVideos-module--intro--a1dfd";
export var playArrow = "MemberVideos-module--playArrow--8f247";
export var playBtn = "MemberVideos-module--playBtn--3ad94";
export var player = "MemberVideos-module--player--250e0";
export var section = "MemberVideos-module--section--a00e3";
export var thumb = "MemberVideos-module--thumb--819e9";
export var thumbPlaceholder = "MemberVideos-module--thumbPlaceholder--f6693";
export var thumbWrap = "MemberVideos-module--thumbWrap--d925d";
export var title = "MemberVideos-module--title--fe28d";